import { Membership } from '@mews-commander/guest-profile';
import { lt } from '@mews/framework';
import { Card, CardContent, Divider, Stack } from '@optimus-web/core';
import { CardHeader } from '../../../../../guestSummaryPanel';
import { LoyaltyItem } from './components';

export interface LoyaltyOverviewProps {
    loyaltyMemberships: Array<Membership>;
}

export const LoyaltyOverview = ({ loyaltyMemberships }: LoyaltyOverviewProps) => (
    <Card>
        <CardContent padding="200">
            <CardHeader title={lt('AccountMergeGuestDetailLoyaltyPrograms')} value={loyaltyMemberships.length} />
        </CardContent>
        <Divider />
        <CardContent padding="200">
            <Stack spacing="200" vertical>
                {loyaltyMemberships.map((item, index) => (
                    <LoyaltyItem
                        key={item.id}
                        membership={item}
                        showDivider={index !== loyaltyMemberships.length - 1}
                    />
                ))}
            </Stack>
        </CardContent>
    </Card>
);
